/* TODO: t() */
import React from 'react';

import { Flex, Text } from '../../core-ui';
import { themeColors } from '../uiold/Constants';

// TODO: Need better design for this
export default function NotFoundPage() {
  return (
    <Flex
      minH="100%"
      alignItems="center"
      justifyContent="center"
      backgroundColor={themeColors.backgroundGrey}
    >
      <Text>Page Not Found</Text>
    </Flex>
  );
}
